const config = {
  // BASE_API: "http://localhost:5005",
  BASE_API: "http://218.195.56.203",
  // BASE_API: "http://47.97.228.234:80",
  REDIRECT_URI: "http://gcrz.pengdikj.com/mobile/#/login/",
  enterprise: "xxx",
  platform: "xxx",
  projectName: "production"
};

export default config;
